import { AlertTriangle, RotateCcw, X } from "lucide-react";

const KEY = "ct_dismissed_expired";

export const dismissedExpired = () => localStorage.getItem(KEY);

export const ExpiredNotice = ({ ride, onRebook, onDismiss }) => {
  const dismiss = () => {
    localStorage.setItem(KEY, ride.id);
    onDismiss();
  };
  return (
    <div data-testid="expired-ride-notice" className="mb-6 flex flex-col gap-4 rounded-2xl border border-orange-200 bg-orange-50 p-5 sm:flex-row sm:items-center">
      <AlertTriangle className="h-6 w-6 shrink-0 text-orange-600" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-900">Sorry — no driver accepted your ride within 30 minutes.</p>
        <p className="truncate text-sm text-slate-600">{ride.pickup.address} → {ride.dropoff.address}. Please rebook and we'll try again.</p>
      </div>
      <div className="flex gap-2">
        <button data-testid="rebook-expired-button" onClick={() => { dismiss(); onRebook(ride); }} className="inline-flex items-center gap-2 rounded-xl bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-600">
          <RotateCcw className="h-4 w-4" /> Rebook this ride
        </button>
        <button data-testid="dismiss-expired-button" onClick={dismiss} className="rounded-xl border border-slate-200 bg-white p-2 text-slate-500 hover:bg-slate-50"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
